import store from '../../store'

let role = 'workman'

export default {
  role,
  guard: () => store.getters['auth/isWorkman'],
  items: [
    {
      label: 'Carico Prodotti',
      name: `Warehouses`,
      items: []
    },
    {
      label: 'Firma',
      name: `Presence`,
      items: []
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/navigator/workman.js